export const STOCK_SUMMARY_DISPLAY = {
  NONE: 'none',
  VIN: 'vin',
};
